import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-5 pb-5 container" }
const _hoisted_2 = { class: "header d-flex justify-content-between align-itens-center col" }
const _hoisted_3 = { class: "m-0" }
const _hoisted_4 = { class: "container-form mb-4" }
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group mb-3 w-25" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "licenseKey" }, "License Key", -1)
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = { class: "form-group mb-3 w-25" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "licenseId" }, "License ID", -1)
const _hoisted_12 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_13 = { class: "form-group mb-3 w-25" }
const _hoisted_14 = { for: "apiPassword" }
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = { class: "row mt-3" }
const _hoisted_17 = { class: "form-group mb-3 w-25" }
const _hoisted_18 = { for: "maxClientLicense" }
const _hoisted_19 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_20 = { class: "form-group mb-3 w-25" }
const _hoisted_21 = { for: "expiration" }
const _hoisted_22 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_23 = { class: "form-group mb-3 w-25" }
const _hoisted_24 = { class: "d-flex gap-3 align-items-center" }
const _hoisted_25 = { class: "flex align-items-center" }
const _hoisted_26 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_27 = {
  for: "active",
  class: "mb-0 ms-2"
}
const _hoisted_28 = { class: "flex align-items-center" }
const _hoisted_29 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_30 = {
  for: "deactivated",
  class: "mb-0 ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_ds_button = _resolveComponent("ds-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.licenseId ? _ctx.$t('license.edit') : _ctx.$t('license.register')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_InputText, {
              id: "licenseKey",
              name: "licenseKey",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.license.licenseKey.$error ? 'p-invalid' : ''}`]),
              modelValue: _ctx.form.license.licenseKey,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.license.licenseKey) = $event)),
              type: "text",
              placeholder: "License Key",
              required: ""
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.form.license.licenseKey.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_InputText, {
              id: "licenseId",
              name: "licenseId",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.license.licenseId.$error ? 'p-invalid' : ''}`]),
              modelValue: _ctx.form.license.licenseId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.license.licenseId) = $event)),
              placeholder: "License ID",
              required: ""
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.form.license.licenseId.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('license.fields.pass')), 1),
            _createVNode(_component_InputText, {
              id: "apiPassword",
              name: "apiPassword",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.license.apiPassword.$error ? 'p-invalid' : ''}`]),
              modelValue: _ctx.form.license.apiPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.license.apiPassword) = $event)),
              placeholder: _ctx.$t('license.fields.pass'),
              required: ""
            }, null, 8, ["modelValue", "placeholder", "class"]),
            (_ctx.v$.form.license.apiPassword.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('license.fields.limit')), 1),
            _createVNode(_component_InputNumber, {
              id: "maxClientLicense",
              name: "maxClientLicense",
              class: _normalizeClass(["d-block maxCliente-input", `w-100 ${_ctx.v$.form.license.maxClientLicense.$error ? 'p-invalid' : ''}`]),
              modelValue: _ctx.form.license.maxClientLicense,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.license.maxClientLicense) = $event)),
              placeholder: "Ex: 3",
              required: ""
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.form.license.maxClientLicense.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_19, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('license.fields.expiration')), 1),
            _createVNode(_component_Calendar, {
              id: "expiration",
              name: "expiration",
              class: _normalizeClass(["d-block expiration-input", `w-100 ${_ctx.v$.form.license.expiration.$error ? 'p-invalid' : ''}`]),
              "date-format": "dd/mm/yy",
              placeholder: "DD/MM/AAAA",
              "min-date": _ctx.minDate,
              modelValue: _ctx.form.license.expiration,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.license.expiration) = $event)),
              required: ""
            }, null, 8, ["min-date", "modelValue", "class"]),
            (_ctx.v$.form.license.expiration.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_22, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('license.fields.status')), 1),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_RadioButton, {
                  inputId: "active",
                  name: "active",
                  value: true,
                  modelValue: _ctx.form.license.active,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.license.active) = $event)),
                  class: _normalizeClass(`${_ctx.v$.form.license.active.$error ? 'p-invalid' : ''}`),
                  required: ""
                }, null, 8, ["modelValue", "class"]),
                (_ctx.v$.form.license.active.$error)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_26, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('license.fields.active')), 1)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_RadioButton, {
                  inputId: "deactivated",
                  name: "deactivated",
                  value: false,
                  modelValue: _ctx.form.license.active,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.license.active) = $event)),
                  class: _normalizeClass(`${_ctx.v$.form.license.active.$error ? 'p-invalid' : ''}`),
                  required: ""
                }, null, 8, ["modelValue", "class"]),
                (_ctx.v$.form.license.active.$error)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_29, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('license.fields.inactive')), 1)
              ])
            ])
          ])
        ]),
        _createVNode(_component_ds_button, {
          type: "secondary",
          text: _ctx.$t('utils.back'),
          class: "float-start me-3 button",
          onClick: _cache[7] || (_cache[7] = () => _ctx.$router.push({ name: 'Licenses' }))
        }, null, 8, ["text"]),
        _createVNode(_component_ds_button, {
          type: "primary",
          text: _ctx.$t('utils.save'),
          class: "float-start button",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sendLicense()))
        }, null, 8, ["text"])
      ])
    ])
  ]))
}